var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirectStoreLinkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8332 3.33317C11.8332 2.96498 12.1316 2.6665 12.4998 2.6665H16.6665C17.0347 2.6665 17.3332 2.96498 17.3332 3.33317V7.49984C17.3332 7.86803 17.0347 8.1665 16.6665 8.1665C16.2983 8.1665 15.9998 7.86803 15.9998 7.49984V3.99984H12.4998C12.1316 3.99984 11.8332 3.70136 11.8332 3.33317Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1379 2.86177C17.3983 3.12212 17.3983 3.54423 17.1379 3.80458L11.3046 9.63791C11.0442 9.89826 10.6221 9.89826 10.3618 9.63791C10.1014 9.37756 10.1014 8.95545 10.3618 8.6951L16.1951 2.86177C16.4554 2.60142 16.8776 2.60142 17.1379 2.86177Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99984 6.49984H8.74984C9.11803 6.49984 9.4165 6.20136 9.4165 5.83317C9.4165 5.46498 9.11803 5.1665 8.74984 5.1665H3.93502C3.59859 5.1665 3.27594 5.30015 3.03804 5.53804C2.80015 5.77594 2.6665 6.09859 2.6665 6.43502V16.0647C2.6665 16.4011 2.80015 16.7237 3.03804 16.9616C3.27594 17.1995 3.59859 17.3332 3.93502 17.3332H13.5647C13.9011 17.3332 14.2237 17.1995 14.4616 16.9616C14.6995 16.7237 14.8332 16.4011 14.8332 16.0647V11.2498C14.8332 10.8816 14.5347 10.5832 14.1665 10.5832C13.7983 10.5832 13.4998 10.8816 13.4998 11.2498V15.9998H3.99984V6.49984Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectStoreLinkOutline);
export default __webpack_public_path__ + "static/media/redirect-store-link-outline.20b6d7a0ac02ce01602f20852ba1b0ff.svg";
export { ForwardRef as ReactComponent };